import React, { FunctionComponent, useEffect, useState } from 'react';
import Button from 'components/Button';
import { ReactComponent as SupportIcon } from 'icons/support.svg';
import styled from 'styled-components';
import { useContactSupportModal } from './Context';

const ContactSupportButton: FunctionComponent = () => {
  const [visible, setVisible] = useState(true);
  const { openModal } = useContactSupportModal();

  useEffect(() => {
    const hideHandler = () => setVisible(false);
    const showHandler = () => setVisible(true);

    document.addEventListener('support:hideButton', hideHandler);
    document.addEventListener('support:showButton', showHandler);

    return () => {
      document.removeEventListener('support:hideButton', hideHandler);
      document.removeEventListener('support:showButton', showHandler);
    };
  }, []);

  return (
    <StyledButtonWrap $visible={visible}>
      <StyledButton
        icon={<SupportIcon width="1.25rem" height="1.25rem" />}
        styleType="blueFill"
        onClick={openModal}
        aria-label="Support"
        data-test="support-launcher"
      >
        Support
      </StyledButton>
    </StyledButtonWrap>
  );
};

export default ContactSupportButton;

const StyledButtonWrap = styled('div')<{ $visible: boolean }>`
  position: fixed;
  width: 134px;
  height: 50px;
  font-feature-settings: 'kern', 'kern';
  font-kerning: normal;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  padding: 0;
  margin: 10px 20px;
  border: 0;
  bottom: 0;
  right: 0;
  overflow: visible;
  z-index: 999998;

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: ${({ $visible }) => ($visible ? 'translateY(0)' : 'translateY(20px)')};
  transition: opacity 250ms cubic-bezier(0.645, 0.045, 0.355, 1),
    transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1);
`;

const StyledButton = styled(Button)`
  box-sizing: border-box;
  border: none;
  border-radius: 999rem;
  display: inline-block;
  letter-spacing: 0.6px;
  line-height: normal;
  font-size: 0.9375rem;
  font-weight: 700;
  padding: 0.8125rem 1.375rem;
  margin: 0;
  min-width: 100%;
  max-width: 100%;
  text-align: left;
  transition: none;
  white-space: nowrap;

  &:hover {
    opacity: unset;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 0.2rem rgba(255, 255, 255, 0.4);
  }

  svg {
    vertical-align: middle;
  }

  .text {
    display: inline-block;
    max-width: 100%;
    padding-left: 0.533rem;
    padding-right: 0;
    vertical-align: middle;
  }
`;
